<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-data-table
        :headers="headers"
        :items="items"
        :loadingCount="loadingCount > 0"
        class="elevation-0"
        hide-actions
      >
        <template v-slot:items="{ item }">
          <tr>
            <td>{{ item.position }}</td>
            <td>{{ item.materialNo }}</td>
            <td>{{ item.description }}</td>
            <td>{{ item.quantity }}</td>
            <td>
              <validation-status-indicator
                :validation-status="item.validationStatus"
              ></validation-status-indicator>
            </td>
            <td>
              <v-icon @click="onDeleteItem(item)">delete</v-icon>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          <v-alert :value="!loadingCount" type="error">
            Unable to parse items from the table in the previous step. Please go
            back and check the content of the table.
          </v-alert>
        </template>
        <template v-slot:footer>
          <tr>
            <td :colspan="headers.length">
              <v-alert type="success" :value="isSuccess">
                {{ itemCountString }} successfully validated.
              </v-alert>
              <v-alert type="warning" :value="isWarning">
                Existing basket will be overwritten.
              </v-alert>
              <v-alert type="error" :value="isError">
                Validation failed for {{ invalidCountString }}.
              </v-alert>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
    <v-flex xs12>
      <v-btn
        color="primary mx-0"
        :disabled="!isSuccess"
        @click="$emit('continue')"
      >
        Add to Basket
      </v-btn>
      <v-btn @click="$emit('back')" flat>Back</v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import pluralize from "pluralize";
import ValidationStatusIndicator from "@/components/ValidationStatusIndicator.vue";

export default {
  components: {
    ValidationStatusIndicator
  },
  data() {
    return {
      headers: [
        { text: "Position", value: "position" },
        { text: "Material No.", value: "materialNo" },
        { text: "Description", value: "description" },
        { text: "Quantity", value: "quantity" },
        { text: "Validation Status", value: "validationStatus" },
        { text: "Remove", sortable: false }
      ]
    };
  },
  computed: {
    items() {
      return this.$store.getters["getTableItems"];
    },
    itemCountString() {
      return pluralize("item", this.items.length, true);
    },
    invalidCount() {
      return this.$store.state.table_to_basket.invalidCount;
    },
    invalidCountString() {
      return pluralize("item", this.invalidCount, true);
    },
    isError() {
      return this.items.length && this.invalidCount > 0;
    },
    isSuccess() {
      return !this.isError && !this.loadingCount;
    },
    isWarning() {
      return this.isSuccess && !!this.$store.state.basket.basketId;
    },
    loadingCount() {
      return this.$store.state.table_to_basket.loadingCount;
    }
  },
  methods: {
    onDeleteItem(item) {
      this.$store.dispatch("removeTableItem", item);
    }
  }
};
</script>
